import * as React from 'react'
import {useEffect} from 'react'
import {observer} from 'mobx-react'
import {useStores} from '../../../lib/MobXProvider'
import {WidgetApi} from '../../../lib/WidgetApi'
import {FooterInfo} from '../common/elements/FooterInfo'

///////////////////////////////////////////////////////////////////////////////

export const EpmsPaymentResponseDataInfoBlock = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()
  const textHTML = api.trans(
    'blocks.payment_status.payment_response_data_info.text_html',
    {defaultValue: null},
  )

  useEffect(() => {
    setTimeout(async () => {
      await api.ui.scrollToTop()
    })
  }, [])

  if (!textHTML) {
    return null
  }

  return (
    <section className="widget-block epms-payment-response-data-info-block">
      <div className="widget-block-content">
        <section className="epms-payment-response-data-info">
          <div className="main" dangerouslySetInnerHTML={{__html: textHTML}} />
        </section>
      </div>
      <FooterInfo />
    </section>
  )
})
